// removed by extract-text-webpack-plugin
module.exports = {"get-started":"_2_WqM","overlay":"BIXZ2","content":"_1Z4Q6","header":"_1wO2L","sub-header":"Lj9xE","button-container":"tJnYc","button":"UNnTN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/GetStarted.less
// module id = ./src/components/Home/GetStarted.less
// module chunks = 2